import { useTenant } from "@/contexts/tenant-provider";

import type { Module } from "@/types/tenant";

/**
 * Hook to check if a specific module is enabled for the current tenant.
 *
 * @param module - The module name to check (e.g., "SPAKINECT", "INVENTORY")
 * @returns boolean indicating if the module is enabled
 *
 * @example
 * ```tsx
 * const hasSpakinect = useModule("SPAKINECT");
 *
 * if (!hasSpakinect) {
 *   return null;
 * }
 *
 * return <SpaKinectFeature />;
 * ```
 */
export function useModule(module: Module): boolean {
  const { tenant } = useTenant();
  return tenant?.enabledModules?.includes(module) ?? false;
}
